// scheduling/components/idd/IDDSubmitPanel.jsx
// Step 3 of the guided flow: how many jobs are ready, what is still missing (with a jump to
// fix each), and the one Submit button. Nothing reaches Practice Engine before this.

const SHOW_MAX = 40;

export default function IDDSubmitPanel({ counts, notReady, onFix, onSubmit, allSubmitted, busy, cycleName, isQA }) {
  if (allSubmitted) {
    return (
      <div className="idd-submit">
        <div className="idd-submit-card idd-submit-card--done">
          <div className="idd-submit-title">Submitted ✓</div>
          <p>Your budgets and dates for <strong>{cycleName}</strong> are in Practice Engine. This page is now read-only for you; ask an admin if something needs to change.</p>
        </div>
      </div>
    );
  }
  const needBudget = notReady.filter(x => x.missing.includes('budget')).length;
  const needDates = notReady.filter(x => x.missing.includes('dates')).length;
  const allReady = counts.total > 0 && counts.ready === counts.total;
  const pct = counts.total ? Math.round((100 * counts.ready) / counts.total) : 0;
  return (
    <div className="idd-submit">
      <div className="idd-submit-card">
        <div className="idd-submit-title">{allReady ? 'Everything is ready' : `${counts.ready} of ${counts.total} jobs ready`}</div>
        <div className="idd-submit-bar" aria-hidden="true"><span style={{ width: `${pct}%` }} /></div>
        {!allReady && (
          <div className="idd-submit-todo">
            {needBudget > 0 && (
              <button className="idd-dec-btn idd-dec-btn--budget" onClick={() => onFix('budgets')}>
                {needBudget} job{needBudget !== 1 ? 's' : ''} still need a budget →
              </button>
            )}
            {needDates > 0 && (
              <button className="idd-dec-btn idd-dec-btn--dates" onClick={() => onFix('dates')}>
                {needDates} job{needDates !== 1 ? 's' : ''} still need dates →
              </button>
            )}
          </div>
        )}
        <p className="idd-submit-note">
          Submit sends every budget and date to Practice Engine and locks this page for you (an admin can reopen it).
          {isQA && <strong> QA sandbox: this is a dry run; nothing reaches Practice Engine.</strong>}
        </p>
        <button className="idd-btn idd-btn--submit idd-submit-btn" disabled={!allReady || busy} onClick={onSubmit}
          title={allReady ? 'Send your budgets and dates to Practice Engine' : 'Finish the jobs above first'}>
          Submit to Practice Engine
        </button>
      </div>
      {notReady.length > 0 && (
        <div className="idd-submit-list">
          <div className="idd-submit-list-title">Not ready yet</div>
          <table className="idd-task-table">
            <thead><tr><th>Client</th><th>Job</th><th>Still needs</th><th /></tr></thead>
            <tbody>
              {notReady.slice(0, SHOW_MAX).map(({ job, missing }) => (
                <tr key={job.PEJobIndex}>
                  <td>{job.ClientCode}</td>
                  <td>{job.JobName}</td>
                  <td>{missing.join(' and ')}</td>
                  <td>
                    <button className="idd-dec-link" onClick={() => onFix(missing[0] === 'budget' ? 'budgets' : 'dates', job.PEJobIndex)}>Fix</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {notReady.length > SHOW_MAX && <div className="idd-cell-sub">…and {notReady.length - SHOW_MAX} more (use the step filters)</div>}
        </div>
      )}
    </div>
  );
}
